<section class="chatting-shell">
  <header class="chatting-header">
    <div class="header-left">
      <div class="header-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path
            d="M7 4v16M17 4v16M3 8h4m10 0h4M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z" />
        </svg>
      </div>
      <div class="header-text">
        <h3>Cinema Assistant</h3>
        <span class="header-status">
          <span class="status-dot" [class.offline]="!isConnected"></span>
          {{ isConnected ? 'Always available' : (isConnecting ? 'Connecting...' : 'Offline') }}
        </span>
      </div>
    </div>
    <div class="header-actions">
      <button type="button" class="ghost-action" (click)="clearChatContext()">
        Clear chat
      </button>
      @if (!isConnected && !isConnecting) {
      <button type="button" class="ghost-action ghost-action-accent" (click)="reconnect()">
        Reconnect
      </button>
      }
    </div>
  </header>

  @if (connectionError) {
  <div class="connection-banner">
    <span>{{ connectionError }}</span>
  </div>
  }

  <div #chatScroll class="chat-window">
    @if (!messages.length && !isThinking) {
    <div class="empty-state">
      <div class="empty-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
          <path
            d="M7 4v16M17 4v16M3 8h4m10 0h4M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z" />
        </svg>
      </div>
      <p class="empty-title">Lights, Camera, Chat</p>
      <p class="empty-sub">Ask me for recommendations, showtimes, or ticket help.</p>
    </div>
    }

    @for (msg of messages; track trackByMessage($index)) {
    <div class="message-row" [class.user-row]="msg.role === 'user'">
      @if (msg.role !== 'user') {
      <div class="avatar-bot">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path
            d="M7 4v16M17 4v16M3 8h4m10 0h4M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z" />
        </svg>
      </div>
      }
      <div class="message-bubble" [class.user-bubble]="msg.role === 'user'">
        @if (msg.media?.url) {
        <div class="media-preview-card" [class.person-card]="msg.media?.type === 'person'">
          <div class="media-image-frame">
            <img [src]="msg.media!.url" [alt]="msg.media!.title || 'Media'" class="media-image" loading="lazy" (error)="onMediaImageError(msg)" />
            @if (msg.media?.type) {
            <span class="media-type-badge">
              {{ msg.media?.type === 'person' ? 'Actor' : (msg.media?.type === 'tv' ? 'TV Series' : 'Movie') }}
            </span>
            }
          </div>
          @if (msg.media?.title) {
          <div class="media-caption">{{ msg.media!.title }}</div>
          }
        </div>
        }
        <div class="message-text">
          {{ msg.cleanContent !== undefined ? msg.cleanContent : msg.content }}
        </div>
      </div>
    </div>
    }

    @if (isThinking) {
    <div class="message-row">
      <div class="avatar-bot">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path
            d="M7 4v16M17 4v16M3 8h4m10 0h4M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z" />
        </svg>
      </div>
      <div class="message-bubble thinking-bubble">
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
      </div>
    </div>
    }
  </div>

  @if (suggestions.length) {
  <div class="suggestion-wrap">
    @for (question of suggestions; track question) {
    <button type="button" class="suggestion-chip" (click)="sendSuggestedQuestion(question)">
      {{ question }}
    </button>
    }
  </div>
  }

  <div class="composer-wrap">
    <textarea class="composer" rows="1" placeholder="Ask about movies, showtimes, tickets…"
      [formControl]="messageControl" (keydown)="handleComposerKeydown($event)"></textarea>

    <button type="button" class="send-btn" [disabled]="!messageControl.value.trim()" (click)="sendMessage()"
      [class.active]="messageControl.value.trim()" aria-label="Send message">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
    </button>
  </div>
</section>